import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { Column, Row } from "simple-flexbox";
import { StyleSheet, css } from "aphrodite";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import FailedImage from "../../assets/mail_unlisted.png"

class ModalFailed extends Component {
  constructor(props) {
    super(props);
  
  }

 

  componentDidMount() {
    
  }

  render() {
    const {show, onHide, email} = this.props;
    return (
      <Modal
        show={show}
        onHide={onHide}
        dialogClassName="modal-width"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
        <div className={css(styles.modalContent)}>
         <img src={FailedImage}></img>
              <h2>Email Tidak Terdaftar</h2>
              <p>Alamat email Anda belum terdaftar, untuk informasi selengkapnya silakan menghubungi admin di  </p>
              <p><b>Whatsapp: </b><a className={css(styles.greenFont)} href="https://wa.me/628111400501">https://wa.me/628111400501</a></p>
              <p><b>Email: </b><a className={css(styles.greenFont)} href="mailto:marcom@indonesia-orthopaedic.org">marcom@indonesia-orthopaedic.org</a></p>
          </div>
        </Modal.Body>
      </Modal >
    );
  }
}

const styles = StyleSheet.create({
    modalContent: {
        padding: "0px 50px 50px 50px",
        textAlign: "center"
    },
    greenFont: {
      color: "#04AA59"
  }
});


export default ModalFailed;
